import type { TrafficSourceItem } from '@metapic-apps/shared'
import { defineStore } from 'pinia'
import { onMounted, ref } from 'vue'

import { normalizeTrafficSources } from '@/lib/adapters/traffic-sources.adapter'
import { handleErrorMessage } from '@/lib/helpers/error.helpers'
import { request } from '@/lib/services'
import { useErrorStore } from '@/stores/error'

export const useTrafficSourcesStore = defineStore('trafficSources', () => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)
  const data = ref<TrafficSourceItem[]>([])

  const errorStore = useErrorStore()

  const fetchData = async () => {
    try {
      isLoading.value = true
      error.value = null
      const response = await request.get('/traffic-sources')
      data.value = normalizeTrafficSources(response.data)
    } catch (e: unknown) {
      errorStore.setError(handleErrorMessage(e))
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }

  onMounted(() => fetchData())

  return { data, isLoading, error, fetchData }
})
